var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 0.5C6.89164 0.5 5.4416 0.939867 4.20823 1.76398C2.97486 2.58809 2.01356 3.75943 1.44591 5.12987C0.87825 6.50032 0.729725 8.00832 1.01911 9.46318C1.3085 10.918 2.02281 12.2544 3.0717 13.3033C4.1206 14.3522 5.45697 15.0665 6.91183 15.3559C8.36668 15.6453 9.87468 15.4968 11.2451 14.9291C12.6156 14.3614 13.7869 13.4001 14.611 12.1668C15.4351 10.9334 15.875 9.48336 15.875 8C15.875 6.01088 15.0848 4.10322 13.6783 2.6967C12.2718 1.29018 10.3641 0.5 8.375 0.5ZM11.1875 4.80687L12.5056 6.125L7.4375 11.1931L4.24438 8L5.5625 6.68187L7.4375 8.55688L11.1875 4.80687Z",
    fill: "#00BA4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrue);
export default __webpack_public_path__ + "static/media/icon-true.4f5e3e226b4b94e07a9f02b803ccbedb.svg";
export { ForwardRef as ReactComponent };